import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/persetujuan-intensif", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/persetujuan-intensif/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/persetujuan-intensif`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/persetujuan-intensif/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function finalize(id: number) {
  const response = await http.putData(`/persetujuan-intensif/${id}/finalize`, {}).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/persetujuan-intensif/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/persetujuan-intensif/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  finalize,
  destroy,
  print
};
